module.exports = __webpack_public_path__ + "media/images/proof_links/imdb-2c929a738a7bc5aa614ffeb33d44ec92.svg";